<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="operationReportData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="configuration">
        <!-- 报告配置 -->
        <Button
          type="info"
          size="small"
          @click="reportConfigurationDetail(row)"
          v-hasPermission="[
            'operationKpiConfigurationManagement:operationReport:report_config'
          ]"
        >
          {{ $t("MCM.automaticalMaintenanceReport.reportConfig") }}
        </Button>
      </template>
    </Table>
    <!-- 删除 -->
    <Modal v-model="operationReportDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{
            $t("alarms.common.sureDelete") +
              companyName +
              $t("ticket.comment.what")
          }}
          ?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeOperationReport()"
        >
          {{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑 -->
    <Modal
      v-model="operationReportEditModal"
      :title="$t('MCM.automaticalMaintenanceReport.edit')"
      :loading="loading"
      @on-ok="operationReportSubmit('operationReportEditForm')"
      @on-cancel="operationReportReset('operationReportEditForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="operationReportEditForm"
        :model="operationReportEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <FormItem
          :label="$t('MCM.automaticalMaintenanceReport.companyName')"
          prop="company"
          >{{ companyNames }}</FormItem
        >

        <!-- 账号  -->
        <FormItem
          :label="$t('MCM.automaticalMaintenanceReport.account')"
          prop="accountSearchKey"
        >
          <Select
            v-model="operationReportEditForm.accountSearchKey"
            filterable
            multiple
            :max-tag-count="1"
            :placeholder="
              $t('MCM.automaticalMaintenanceReport.filterByAccount')
            "
            :transfer="true"
            @on-change="searchAccount(operationReportEditForm.accountSearchKey)"
            style="width: 300px;"
          >
            <Checkbox
              v-model="singleAccount"
              @on-change="selectAccountAll"
              style="display: block;text-align:right;"
              >{{
                $t("configuration_management.customized_alarm_config.checkAll")
              }}</Checkbox
            >
            <Option
              :value="item.id"
              v-for="item in accountList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 区域 -->
        <FormItem
          :label="$t('MCM.automaticalMaintenanceReport.region')"
          prop="regions"
        >
          <Select
            v-model="operationReportEditForm.regions"
            multiple
            style="width:300px;"
          >
            <Option
              v-for="item in regionsList"
              :value="item.key"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 月份 -->
        <FormItem
          :label="$t('MCM.automaticalMaintenanceReport.month')"
          prop="yearMonth"
          >{{ yearMonths }}</FormItem
        >
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <!-- 预览 -->
    <Modal
      v-model="previewModal"
      fullscreen
      :mask-closable="false"
      :closable="false"
    >
      <preview ref="print" :previewEditOldForm="previewEditForm"></preview>
      <div slot="footer" class="btn">
        <Button type="text" @click="closePreview">关闭</Button>
        <Button type="primary" @click="print">打印</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Preview from "../operation_report/Preview";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

var tableOperationReportVue = {};
export default {
  name: "TableOperationReport",
  components: {
    Preview
  },
  data() {
    return {
      previewEditForm: {},
      previewModal: false, //打印预览
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      operationReportDelmodal: false, //删除
      modal_loading: false,
      regionsList: [], //区域
      companyName: "", //查询参数
      companyNames: "",
      company: "",
      accountId: "",
      yearMonth: "",
      yearMonths: "",
      singleAccount: false, // 账号
      accountList: [],
      operationReportEditModal: false, //编辑
      loading: true,
      operationReportEditForm: {
        accountSearchKey: [],
        regions: []
      },
      columns: [
        {
          title: this.$t("MCM.automaticalMaintenanceReport.companyName"),
          key: "companyName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.operationReportEditForm.id = params.row.id;
                    // 公司
                    this.companyNames = params.row.companyName;
                    // 账号
                    this.$api.account
                      .queryAccountListByCompanyIdAndCloudType({
                        companyId: params.row.companyId,
                        cloudPlatformType: 0
                      })
                      .then(res => {
                        this.accountList = res.data;
                      });
                    setTimeout(() => {
                      this.operationReportEditForm.accountSearchKey =
                        params.row.accountIdList;
                    }, 1000);

                    setTimeout(() => {
                      this.operationReportEditForm.regions =
                        params.row.regionList;
                    }, 1000);

                    // 月份
                    this.yearMonths = params.row.reportDate;
                    this.operationReportEditModal = true; //编辑弹出层
                  }
                }
              },
              params.row.companyName
            );
          }
        },
        {
          title: this.$t("MCM.automaticalMaintenanceReport.account"),
          key: "accountNameList"
        },
        {
          title: this.$t("MCM.automaticalMaintenanceReport.month"),
          key: "reportDate"
        },
        {
          title: this.$t("MCM.automaticalMaintenanceReport.region"),
          key: "regions"
        },
        {
          title: this.$t("MCM.automaticalMaintenanceReport.config"),
          slot: "configuration"
        },
        {
          title: this.$t("MCM.automaticalMaintenanceReport.operation"),
          key: "operations",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    "margin-right": "5px"
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "operationKpiConfigurationManagement:operationReport:overview"
                      )
                    }
                  ],
                  on: {
                    click: () => {
                      // 父组件向子组件传值
                      this.previewEditForm = params.row;
                      setTimeout(() => {
                        this.$refs.print.queryById();
                        this.$refs.print.eventOverviews();
                        this.$refs.print.annualMonthlyExpensess();
                        this.$refs.print.selectReportEventList();
                        // EC2优化建议&RDS优化建议
                        this.$refs.print.selectReportOptimizeListInstance();
                        // 降级前后花费对比
                        this.$refs.print.selectReportOptimizeListComparison();
                        // 预留实例推荐花费对比
                        this.$refs.print.listReportReservedInstances();
                        // RI匹配情况
                        this.$refs.print.listProdEnvironmentReservedInstance();
                        // 本月运维事件
                        this.$refs.print.selectOperationEvents();
                        // 上月待处理事件
                        this.$refs.print.selectEventsPending();
                        this.previewModal = true;
                      }, 2000);
                    }
                  }
                },
                this.$t("MCM.automaticalMaintenanceReport.preview")
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.doOperations(params.index);
                      this.operationReportDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "operationKpiConfigurationManagement:operationReport:delete"
                      )
                    }
                  ]
                },
                this.$t("common.del")
              )
            ]);
          }
        }
      ],
      ruleValidate: {
        accountSearchKey: [
          {
            required: true,
            type: "array",
            message: this.$t(
              "MCM.automaticalMaintenanceReport.pleaseSelectAccount"
            )
          }
        ],
        regions: [
          {
            required: true,
            type: "array",
            message: this.$t(
              "MCM.automaticalMaintenanceReport.pleaseSelectRegion"
            ),
            trigger: "change"
          }
        ]
      },
      operationReportData: []
    };
  },
  beforeCreate: function() {
    tableOperationReportVue = this;
  },
  mounted: function() {
    tableOperationReportVue.getOperationReportData();
  },
  methods: {
    // 点击报告配置跳转
    reportConfigurationDetail: function(row) {
      this.$router.push({
        path: "/operationKpiConfigurationManagement/reportConfiguration/",
        query: {
          reportId: row.id,
          companyId: row.companyId,
          reportDate: row.reportDate,
          accountIdList: JSON.stringify(row.accountIdList),
          companyName: row.companyName
        }
      });
    },
    /***********账号**************************/
    selectAccountAll() {
      this.operationReportEditForm.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.operationReportEditForm.accountSearchKey.push(item.id);
        });
      } else {
        this.operationReportEditForm.accountSearchKey = [];
      }
    },
    // 切换账号
    searchAccount: function(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      //根据账号查询账号关联的区域
      this.$api.account.queryRegionsByAccounts("accountIds", val).then(res => {
        this.regionsList = res.data;
      });
    },
    /**************************分页****************************/
    showAll: function() {
      tableOperationReportVue.getOperationReportData();
    },
    // 分页显示数据
    getOperationReportData: function() {
      eventBus.$on("company", function(company) {
        tableOperationReportVue.company = company;
      });
      eventBus.$on("accountId", function(accountId) {
        tableOperationReportVue.accountId = accountId;
      });
      eventBus.$on("yearMonth", function(yearMonth) {
        tableOperationReportVue.yearMonth = yearMonth;
      });
      // 列表分页
      this.$api.report
        .pageReport({
          companyName: tableOperationReportVue.company,
          accountName: tableOperationReportVue.accountId,
          month: tableOperationReportVue.yearMonth,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.operationReportData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableOperationReportVue.getOperationReportData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableOperationReportVue.getOperationReportData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("company");
      eventBus.$off("accountId");
      eventBus.$off("accountId");
    },
    /**************************删除****************************/
    // 删除
    doOperations: function(index) {
      this.lineIndex = index;
      this.companyName = this.operationReportData[index].companyName;
    },
    removeOperationReport: function() {
      var lineIndex = this.lineIndex;
      // 删除
      this.$api.report
        .deleteReport("id", this.operationReportData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableOperationReportVue.getOperationReportData();
            this.modal_loading = false;
            this.operationReportDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 确定
    operationReportSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.report
            .updateReport({
              id: this.operationReportEditForm.id,
              accountIdList: this.operationReportEditForm.accountSearchKey,
              regions: this.operationReportEditForm.regions
            })
            .then(res => {
              setTimeout(() => {
                tableOperationReportVue.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("编辑成功");
                this.operationReportEditModal = false;
              }, 1000);
            });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("编辑失败");
        }
      });
    },
    // 取消
    operationReportReset: function(name) {
      this.$refs[name].resetFields();
    },
    /**************************预览****************************/
    //调用系统打印机
    print() {
      this.$print(this.$refs.print); // 使用
    },
    // 关闭
    closePreview: function() {
      this.previewModal = false;
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}

@media print {
  .btn {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/TableOperationReport.vue